<template>
  <div class="location-container">
    <div class="location-sub-container" v-if="getOrderLater == true">
      <div class="location-info-first">
        <!-- <div class="location-key" @click="getOulets('btn')"> -->
        <div class="location-key">
          Location
          <!-- <i class="fa fa-pencil"></i> -->
        </div>
        <div class="location-value">{{ setOutletName }}</div>
        <div class="location-open-close-time" v-for="outlet in outletInformation" :key="outlet.store_id">
          Open Time: {{ getTime(outlet.day_start_time) }} -
          {{ getTime(outlet.day_close_time) }}
        </div>
      </div>
      <div class="location-order-type">
        <div class="location-key" @click="changeOrderType">
          Order Type
          <i class="fa fa-pencil"></i>
        </div>
        <div class="location-value">
          <span v-if="tempOrderType == 'dinein'">Dinein</span>
          <span v-if="tempOrderType == 'pickup'">Pickup</span>
          <span v-if="tempOrderType == 'delivery'">Delivery</span>
        </div>
      </div>
      <div class="location-order-date" v-if="digital_order_setting.order_later == 1">
        <div class="location-key" @click="changeOrderLaterDateTime">
          Order Later <i class="fa fa-pencil"></i>
        </div>
        <div class="location-value">
          {{ orderdatetoshow }} : {{ order_later_start_time }}
        </div>
      </div>
      <!--  <div class="location-btn-change">
        <button @click="getOulets('btn')" class="location-btn-open">
          <i class="fa fa-map-marker"></i> Change Location
        </button>
      </div> -->
    </div>
    <div class="location-sub-container" v-if="getOrderNow == true">
      <div class="location-info-first">
        <!-- <div class="location-key" @click="getOulets('btn')">
          Location
          <i class="fa fa-pencil"></i>
        </div> -->
        <div class="location-value">{{ setOutletName }}</div>
        <div class="location-open-close-time" v-for="outlet in outletInformation" :key="outlet.store_id">
          Open Time: {{ getTime(outlet.day_start_time) }} -
          {{ getTime(outlet.day_close_time) }}
        </div>
      </div>
      <div class="location-order-type">
        <div class="location-key" @click="changeOrderType">
          Order Type
          <i class="fa fa-pencil"></i>
        </div>
        <div class="location-value">
          <span v-if="tempOrderType == 'dinein'">Dinein</span>
          <span v-if="tempOrderType == 'pickup'">Pickup</span>
          <span v-if="tempOrderType == 'delivery'">Delivery</span>
        </div>
      </div>
      <div class="location-order-date" v-if="digital_order_setting.order_later == 1">
        <div class="location-key" @click="changeOrderLaterDateTime">
          Order Now <i class="fa fa-pencil"></i>
        </div>
      </div>
      <div class="location-btn-change">
        <!-- <button @click="getOulets('btn')" class="location-btn-open">
          <i class="fa fa-map-marker"></i> Change Location
        </button> -->
      </div>
    </div>

    <b-modal v-model="modalShow" hide-footer hide-header id="modal-center-outlet-location" class="modal centered-modal">
      <div class="modal-body">
        <div class="modal-close-btn">
          <span @click="closeModalLocation">&times;</span>
        </div>
        <div class="modal-body-sub-container">
          <div class="modal-body-title">
            <h5>Choose Outlet</h5>
          </div>
          <div class="modal-body-form">
            <b-form-select class="form-control" v-model="selected" :options="options"></b-form-select>
          </div>
          <b-button class="modal-submit-btn" @click="setOutletID" block>Order Now</b-button>
        </div>
      </div>
    </b-modal>

    <b-modal v-model="order_type_modal" hide-footer hide-header id="modal-center-order-type" class="modal centered-modal">
      <div class="modal-body">
        <div class="modal-close-btn">
          <span @click="closeModalOrderType">&times;</span>
        </div>
        <div class="modal-body-sub-container">
          <div class="modal-body-title">
            <h5>Choose Order Type</h5>
          </div>
          <div class="modal-body-form">
            <div class="order-type-choose" v-for="outlet in outletInformation" :key="outlet.store_id">
              <b-form-radio class="order-type-radio" v-if="outlet.digital_ordering_settings.other.dinein == 1"
                v-model="deliverytype" name="some-radios" value="dinein" @change="filterChanged(deliverytype)">Dine In
              </b-form-radio>
              <b-form-radio class="order-type-radio" v-if="outlet.digital_ordering_settings.other.pickup == 1"
                v-model="deliverytype" name="some-radios" value="pickup" @change="filterChanged(deliverytype)">Pickup
              </b-form-radio>
              <b-form-radio class="order-type-radio" v-if="outlet.digital_ordering_settings.other.delivery == 1"
                v-model="deliverytype" name="some-radios" value="delivery" @change="filterChanged(deliverytype)">
                Delivery</b-form-radio>
            </div>
            <b-form-input class="form-control order-type-dinein-input" v-if="deliverytype == 'dinein'"
              v-model="table_room_no" id="usernote" placeholder="Enter Table/Room No" type="text"></b-form-input>
            <div v-if="deliverytype == null" style="color: red">
              <strong>{{ error }}</strong>
            </div>
            <b-button class="modal-submit-btn" @click="closeModal" block>Order Now</b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal hide-footer hide-header id="modal-center-order-later" class="modal centered-modal"
      v-model="order_later_modal">
      <div class="modal-body">
        <div class="modal-close-btn">
          <span @click="closeModalOrderLaterClose">&times;</span>
        </div>
        <div class="modal-body-sub-container">
          <div class="modal-body-title">
            <h5>When do you want your order?</h5>
          </div>
          <div class="modal-body-form">
            <div class="">
              <div class="col-md-6 col-6 btn-order-now">
                <b-button v-if="order_now === false" class="btn-sub-order-now1" variant="primary" block
                  @click="orderTimeOption('now')">Order Now</b-button>
                <b-button v-if="order_now === true" class="btn-sub-order-now1" variant="primary" block
                  @click="orderTimeOption('now')">Order Now</b-button>
              </div>
              <div class="col-md-6 col-6 btn-order-now">
                <b-button v-if="order_later === false" class="btn-sub-order-now2" variant="primary" block
                  @click="orderTimeOption('later')">Order Later</b-button>
                <b-button v-if="order_later === true" class="btn-sub-order-now2" variant="primary" block
                  @click="orderTimeOption('later')">Order Later</b-button>
              </div>
            </div>
            <div class="order-later-date-time">
              <div class="col-md-6 col-6 btn-order-later" v-if="order_later == true">
                <datetime type="date" :format="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }" :phrases="{ ok: 'Ok', cancel: 'Exit' }" placeholder="Select Date" v-model="datetimeEmpty"
                  :min-datetime="minDatetime" :max-datetime="maxDatetime"></datetime>
              </div>
              <div class="col-md-6 col-6 btn-order-later" v-if="order_later == true">
                <b-dropdown class="order-later-dropdown" :text="selected_order_time_slots" block>
                  <b-dropdown-item class="order-later-item" v-for="(item, key) in order_later_time_slots" :key="key"
                    :value="item.start_time + ' - ' + item.end_time" @click="
                      setSelectedTimeSlot(
                        item.start_time + ' - ' + item.end_time,
                        item.start_time
                      )
                      ">
                    {{ item.start_time + " - " + item.end_time }}
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </div>
          <b-button class="modal-submit-btn" block @click="closeModalOrderLater">Confirm & Continue</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
//import Vue from 'vue';
import { mapGetters } from "vuex";
//import MapComponent from "./MapComponent";
import * as VueGoogleMaps from "vue2-google-maps";
import { Datetime } from "vue-datetime";
import moment from "moment";
export default {
  name: "Location",
  data() {
    return {
      selected: null,
      modalShow: false,
      options: [],
      selected_outlet_name: "",
      order_type_modal: false,
      deliverytype: localStorage.getItem("deliverytype"),
      error: "",
      del_address: localStorage.getItem("del_address"),
      table_room_no: localStorage.getItem("table_room_no")
        ? localStorage.getItem("table_room_no")
        : "",
      userinfolocal: localStorage.getItem("userinfo")
        ? JSON.parse(localStorage.getItem("userinfo"))
        : [],
      tempOrderType: localStorage.getItem("deliverytype"),
      minDatetime: "",
      maxDatetime: "",
      datetimeEmpty: "",
      ordertime: "",
      orderlaterselected: "radio1",
      orderoptions: [
        { text: "Order Now", value: "now" },
        { text: "Order Later", value: "later" },
      ],
      order_later: false,
      order_now: true,
      order_later_modal: false,
      orderdatetoshow: "",
      ordertimetoshow: "",
      order_later_time_slots: "",
      selected_order_time_slots: "Select Time",
      order_later_start_time: "",
    };
  },
  components: {
    //MapComponent,
    datetime: Datetime,
  },
  computed: {
    ...mapGetters(["setOutletName"]),
    ...mapGetters(["outletInformation"]),
    ...mapGetters(["getOrderType"]),
    ...mapGetters(["digital_order_setting"]),
    ...mapGetters(["cartItemCount"]),
    ...mapGetters(["getOrderLater"]),
    ...mapGetters(["getOrderNow"]),
    ...mapGetters(["getOrderDate"]),
    ...mapGetters(["getOrderTime"]),
    google: VueGoogleMaps.gmapApi,
  },
  methods: {
    setSelectedTimeSlot(value, start_time) {
      var today = new Date();
      var day = today.getDate();
      var month = today.getMonth() + 1;
      var year = today.getFullYear();

      // alert("year is " + year + "/" + month + "/" + day);

      // this.datetimeEmpty = year + "/" + month + "/" + day;

      //this.datetimeEmpty = year + "/" + month + "/" + day;
      let tempdt = year + "-" + month + "-" + day;
      //console.log("tempdt ", tempdt);
      this.selected_order_time_slots = value;
      this.order_later_start_time = value;
      //2021-11-29T19:15:00.000+05:30
      //2021-11-30T09:30:00.000+05:30
      //2021-11-29T11:45:00.000+05:30
      var dt = moment(start_time, ["h:mm A"]).format("HH:mm");
      //console.log("dt ", dt);
      var temptime = tempdt + "T" + dt + ":00.000+05:30";

      //console.log("temptime ", temptime);
      /* var todayTime = new Date(temptime);
      var h = todayTime.getHours();
      var m = todayTime.getMinutes();
      //  var s = today.getSeconds();
      var now = h + ":" + m + ":" + "00";
      // console.log("today ", now); */

      this.ordertime = temptime;
      localStorage.setItem(
        "order_later_start_time",
        this.order_later_start_time
      );
    },
    changeOrderLaterDateTime() {
      this.$bvModal.show("modal-center-order-later");

      // this.datetimeEmpty = this.getOrderDate;

      /*  alert("getOrderTime ", this.getOrderTime);
      alert("getOrderDate ", this.getOrderDate);
      alert("getOrderLater ", this.getOrderLater);
      alert("getOrderNow ", this.getOrderNow); */
    },
    validateDate() {
      if (this.datetimeEmpty != "") {
        var today = new Date(this.datetimeEmpty);
        var day = today.getDate();
        var month = today.getMonth() + 1;
        var year = today.getFullYear();

        // alert("year is " + year + "/" + month + "/" + day);

        this.datetimeEmpty = year + "/" + month + "/" + day;
      }
    },
    validateTime() {
      //   alert("selected time is " + this.ordertime);

      if (this.ordertime != "") {
        var today = new Date(this.ordertime);
        var h = today.getHours();
        var m = today.getMinutes();
        //  var s = today.getSeconds();
        var now = h + ":" + m + ":" + "00";

        //  alert("Now is "+now)

        var format = "hh:mm:ss";
        var time = moment(now, format);
        var beforeTime = moment(
          this.digital_order_setting.day_start_time,
          format
        );
        var afterTime = moment(
          this.digital_order_setting.day_close_time,
          format
        );

        if (time.isBetween(beforeTime, afterTime)) {
          //alert('is between '+now)
          this.ordertime = now;
        } else {
          //alert('is not between')

          this.ordertime = "";
          this.$bvToast.toast("Please Select Another time.", {
            variant: "danger",
            toaster: "b-toaster-bottom-left",
            solid: true,
          });
        }
      }
    },
    orderTimeOption(value) {
      if (value === "later") {
        this.order_later = true;
        this.order_now = false;
        this.$store.dispatch("saveOrderLater", {
          order_later: this.order_later,
        });
        this.$store.dispatch("saveOrderNow", {
          order_now: this.order_now,
        });
      }

      if (value === "now") {
        this.order_later = false;
        this.order_now = true;
        this.$store.dispatch("saveOrderLater", {
          order_later: this.order_later,
        });
        this.$store.dispatch("saveOrderNow", {
          order_now: this.order_now,
        });
      }
    },
    getTime(time) {
      // Check correct time format and split into components
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
      if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      //[ 11, ":", "00", ":00", null, "AM" ]
      var hh = time[0];
      var mm = time[2];
      var tm = time[5];
      var finaltime = hh + ":" + mm + " " + tm;
      //time = time[0]
      return finaltime; // return adjusted time or original string
    },
    closeModalOrderType() {
      /*
                      let storelat = localStorage.getItem('storelat');
                      let storelng = localStorage.getItem('storelng');

                      //console.log("storelat "+storelat)
                   
                   if(this.deliverytype === 'delivery'){

        if((storelat == undefined || storelat == null) && (storelng == undefined || storelng == null)) {
                        this.$bvToast.toast("Please select location", {
                              variant: 'danger',
                              toaster: 'b-toaster-bottom-left',
                              solid: true,
                       })

                        return
                      }

                   }*/
      //alert("Hello");
      this.order_type_modal = false;
    },
    closeModalLocation() {
      this.modalShow = false;
    },
    filterChanged(value) {
      // alert('delivery type in local storage '+ localStorage.getItem('deliverytype'))
      this.$store.dispatch("saveOrderType", {
        ordertype: value,
      });

      //alert("value "+value)

      /* if (value === "dinein" || value === "delivery") {
        this.order_type_modal = true;
      } */
      /* localStorage.removeItem("table_room_no");
           this.table_room_no = ''*/
      localStorage.setItem("deliverytype", value);
    },
    setOutletID() {
      //alert("Selected text "+this.selected.text)

      this.$store.dispatch("clearCartItems");
      this.$store.dispatch("setOutlet", null);
      let currentObj = this;
      /* commented for the bowls n boxes*/
      this.modalShow = false;
      //localStorage.removeItem("deliverytype");
      //localStorage.removeItem("table_room_no");
      //alert('Delivery type is '+ this.deliverytype)
      if (
        this.digital_order_setting.ask_for_ordertype_before_placing_order == 1
      ) {
        if (
          this.deliverytype == "null" ||
          this.deliverytype == null ||
          localStorage.getItem("deliverytype") == "null" ||
          localStorage.getItem("deliverytype") == null
        ) {
          //alert('Delivery type is '+ this.deliverytype)
          //	this.order_type_modal = true
          //NotificationHere
        }
      }

      setTimeout(function () {
        // alert("selected ", this.selected);
        currentObj.$store.dispatch("setOutlet", currentObj.selected);
        currentObj.options.find((options) => {
          if (options.value == currentObj.selected) {
            //alert(options.text)
            currentObj.$store.dispatch("setOutletName", options.text);
          }
        });
      }, 500);
    },
    getOulets(event) {
      // alert(event);
      let currentObj = this;
      if (this.options.length <= 0) {
        let tmposid = "";
        //tmposid = "53456436" //pizza nation
        //tmposid = "77724317" //SDk resto
        // tmposid = "68719815" // maitis food
        // tmposid = "53456436"; // food2all
        // tmposid = "87147092"; // grillfry
        // tmposid = "11042406"// sagar ratna
        //tmposid = "28424161"; // bowls n boxes
        // tmposid = "78385705" // ariose
        // tmposid = "47665831"// beintehaanbiryani_website
        // tmposid = "15038797" // broasted
        //  tmposid = "87636111"; // dip
        // tmposid = "92108771"; // swadisht
        // tmposid = "61464683"; // mughliazz
        //New customer tmposid
        // tmposid = "9441443"; //Puchkawale Theme color - #ffbb0e
        // tmposid = "51807799"; // Vegfual Theme color - #ffbb0e
        tmposid = "20432833"; //kurrykingdom theme color : #5d221c

        currentObj.axios
          .get("outlets_and_menu/" + tmposid)
          .then(function (response) {
            let outlets = [];
            outlets = response.data.outlets;
            //  alert(this.setOutletName)
            for (var i in outlets) {
              let outlet_id = outlets[i].id;
              let outlet_name = outlets[i].name;
              //alert(outlet_name)
              if (i == 0) {
                //If pop up not required uncomment this line
                //if (i == 1) {
                //  if (i == 2) {
                // if(this.setOutletName == '') {}
                /*  alert(
                  "userinfo ",
                  JSON.parse(localStorage.getItem("userinfo"))
                );
                alert("test ", JSON.parse(currentObj.$cookie.get("test"))); */
                if (
                  localStorage.getItem("userinfo") == null ||
                  localStorage.getItem("userinfo") == "null"
                ) {
                  currentObj.selected = outlet_id;
                  currentObj.selected_outlet_name = outlet_name;
                  currentObj.$store.dispatch("setOutlet", outlet_id);
                  currentObj.$store.dispatch("setOutletName", outlet_name);
                } else {
                  // alert("Hello");
                  outlet_id = localStorage.getItem("selected_outlet_id ");
                  outlet_name = localStorage.getItem("selected_outlet_name ");
                  currentObj.selected = outlet_id;
                  currentObj.selected_outlet_name = outlet_name;
                  currentObj.$store.dispatch("setOutlet", outlet_id);
                  currentObj.$store.dispatch("setOutletName", outlet_name);
                }
              }

              // alert("outlet_name ", outlet_name);
              currentObj.options.push({
                value: outlet_id,
                text: outlet_name,
              });
            }
            // console.log("options is "+JSON.stringify(currentObj.options))
          })
          .catch((error) => {
            console.log(error);
          });
      }
      //   alert("User info "+ localStorage.getItem('userinfo'))
      // console.log(localStorage.getItem("userinfo"), this.cartItemCount);
      // if (localStorage.getItem("userinfo") == null && this.cartItemCount == 0) {
      //   //alert("Empty")
      //   // this.modalShow = true; //If pop up not required then comment this line
      // } else {
      //   //  alert("Not Empty")

      // }

      if (event == "btn") {
        this.modalShow = true; //If pop up not required then comment this line
        if (
          localStorage.getItem("userinfo") !== null &&
          this.cartItemCount > 0
        ) {
          //  alert("12");
          this.$bvToast.toast(
            "For selecting another outlet items you need to empty cart first",
            {
              variant: "danger",
              toaster: "b-toaster-bottom-left",
              solid: true,
            }
          );
        } else if (
          (localStorage.getItem("userinfo") == null ||
            localStorage.getItem("userinfo") == "null") &&
          this.cartItemCount > 0
        ) {
          // alert("Hello");
          this.$bvToast.toast(
            "For selecting another outlet you need to empty cart first",
            {
              variant: "danger",
              toaster: "b-toaster-bottom-left",
              solid: true,
            }
          );
        } else {
          // alert("123");
          this.$bvToast.toast(
            "For selecting another outlet you need to logout first",
            {
              variant: "danger",
              toaster: "b-toaster-bottom-left",
              solid: true,
            }
          );
        }
      }
    },
    changeOrderType() {
      // alert("In changeOrderType")
      // alert(this.order_type_modal)
      this.order_type_modal = true;
      //	this.deliverytype = this.tempOrderType
      /* this.$bvToast.toast(`Please select Order Type First`, {
        variant: "danger",
        toaster: "b-toaster-bottom-left",
        solid: true,
        autoHideDelay: 2000,
      }); */
    },
    openModalOrderType() {
      // alert("In changeOrderType");

      // this.order_type_modal = true;
      //	this.deliverytype = this.tempOrderType
      this.$bvModal.show("modal-center-order-type");
      // alert("deliverytype "+this.deliverytype)

      /* this.$bvToast.toast(`Please select Order Type First`, {
        variant: "danger",
        toaster: "b-toaster-bottom-left",
        solid: true,
        autoHideDelay: 2000,
      }); */
    },
    closeModal() {
      if (this.deliverytype != null) {
        localStorage.setItem("table_room_no", this.table_room_no);
        if (this.deliverytype === "delivery") {
          /*   //this.$bvModal.hide('modal-sm')
          let storelat = localStorage.getItem("storelat");
          let storelng = localStorage.getItem("storelng");
          //console.log("storelat "+storelat)
          if (
            (storelat == undefined || storelat == null) &&
            (storelng == undefined || storelng == null)
          ) {
            this.$bvToast.toast("Please select location", {
              variant: "danger",
              toaster: "b-toaster-bottom-left",
              solid: true,
            });
            return;
          }
          let deliverylimit = localStorage.getItem("deliverylimit");

          var finaldistance = localStorage.getItem("deliverylocation");
          
          if (parseFloat(finaldistance) > parseFloat(deliverylimit)) {
            currentObj.$bvToast.toast(`Sorry !!! Location is not Serviceable`, {
              variant: "danger",
              toaster: "b-toaster-bottom-left",
              solid: true,
              autoHideDelay: 2000,
            });

            return;
          } else {
            
            currentObj.del_address = localStorage.getItem("del_address");
          }

 */
          let currentObj = this;
          currentObj.order_type_modal = false;
          // this.$bvModal.show("modal-center-order-later");
        } else {
          if (this.deliverytype == "dinein") {
            if (this.table_room_no == "" || this.table_room_no == undefined) {
              this.$bvToast.toast("Please enter table or room number", {
                variant: "danger",
                toaster: "b-toaster-bottom-left",
                solid: true,
              });
              return;
            }
            this.order_type_modal = false;
          }
          this.order_type_modal = false;
          //
        }

        this.tempOrderType = this.deliverytype;
        //alert('Distance is '+ finaldistance)
        localStorage.removeItem("table_room_no");
        this.table_room_no = "";
        localStorage.setItem("deliverytype", this.deliverytype);

        if (this.digital_order_setting.order_later == 1) {
          this.$bvModal.show("modal-center-order-later");
        } else {
          this.order_later = false;
          this.order_now = true;

          localStorage.setItem("order_later", this.order_later);
          localStorage.setItem("order_now", this.order_now);

          this.$store.dispatch("saveOrderLater", {
            order_later: this.order_later,
          });
          this.$store.dispatch("saveOrderNow", {
            order_now: this.order_now,
          });
        }
      } else {
        this.error = "Please select delivery type";
      }
    },
    closeModalOrderLater() {
      localStorage.removeItem("order_later");
      localStorage.removeItem("order_now");
      localStorage.removeItem("ordertime");
      localStorage.removeItem("orderdate");

      if (this.order_later == true && this.datetimeEmpty == "") {
        this.$bvToast.toast("Please enter valid date for Order Later", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      if (this.order_later == true && this.ordertime == "") {
        this.$bvToast.toast("Please enter valid time for Order Later", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      this.$store.dispatch("saveOrderLater", {
        order_later: this.order_later,
      });
      this.$store.dispatch("saveOrderNow", {
        order_now: this.order_now,
      });

      var today = new Date(this.datetimeEmpty);
      var day = today.getDate();
      var month = today.getMonth() + 1;
      var year = today.getFullYear();

      // alert("year is " + year + "/" + month + "/" + day);

      // this.datetimeEmpty = year + "/" + month + "/" + day;

      //this.datetimeEmpty = year + "/" + month + "/" + day;
      this.orderdatetoshow = day + "/" + month + "/" + year;

      //console.log("this.ordertime is " + this.ordertime);

      /*  var todayTime = new Date(this.ordertime);
      var h = todayTime.getHours();
      var m = todayTime.getMinutes();
      //  var s = today.getSeconds();
      var now = h + ":" + m + ":" + "00"; */

      //  alert("Now is "+now)

      /*  var format = "hh:mm:ss";
      var time = moment(now, format);
      var beforeTime = moment(
        this.digital_order_setting.day_start_time,
        format
      );
      var afterTime = moment(this.digital_order_setting.day_close_time, format); */

      //this.ordertime = now;

      //  this.ordertimetoshow = now;
      /* if (time.isBetween(beforeTime, afterTime)) {
        //alert('is between '+now)
       
      } else {
        //alert('is not between')

        this.ordertime = "";
        this.$bvToast.toast("Please Select Another time.", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      } */

      // alert(this.ordertime);
      //  alert(this.datetimeEmpty);

      if (this.order_later == false) {
        this.ordertime = "";
        this.datetimeEmpty = "";
      }

      this.$store.dispatch("saveOrderDate", {
        order_date: this.datetimeEmpty,
      });
      this.$store.dispatch("saveOrderTime", {
        order_time: this.ordertime,
      });

      localStorage.setItem("order_later", this.order_later);
      localStorage.setItem("order_now", this.order_now);

      localStorage.setItem("ordertime", this.ordertime);
      localStorage.setItem("orderdate", this.datetimeEmpty);
      localStorage.setItem(
        "selected_order_time_slots",
        this.selected_order_time_slots
      );
      this.$bvModal.hide("modal-center-order-later");
    },
    closeModalOrderLaterClose() {
      // alert(this.datetimeEmpty);
      this.$bvModal.hide("modal-center-order-later");
    },
    deg2rad(deg) {
      return deg * (Math.PI / 180);
    },
  },

  created() {
    // console.log("created");
    //alert("deliverytype "+this.deliverytype)
    if (this.setOutletName == 0) {
      this.getOulets("load");
      if (
        this.digital_order_setting.ask_for_ordertype_before_placing_order == 1
      ) {
        if (
          this.deliverytype == "null" ||
          this.deliverytype == null ||
          localStorage.getItem("deliverytype") == "null" ||
          localStorage.getItem("deliverytype") == null
        ) {
          //alert('Delivery type is '+ this.deliverytype)
          this.order_type_modal = true;
        }
      }
    }
  },
  mounted() {
    // alert("mounted ", this.getOrderTime);
    //console.log("mounted");
    var today = new Date(localStorage.getItem("orderdate"));
    var day = today.getDate();
    var month = today.getMonth() + 1;
    var year = today.getFullYear();

    // alert("year is " + year + "/" + month + "/" + day);

    // this.datetimeEmpty = year + "/" + month + "/" + day;

    //this.datetimeEmpty = year + "/" + month + "/" + day;
    this.orderdatetoshow = day + "/" + month + "/" + year;

    var todayTime = new Date(localStorage.getItem("ordertime"));
    var h = todayTime.getHours();
    var m = todayTime.getMinutes();
    //  var s = today.getSeconds();
    var now = h + ":" + m + ":" + "00";
    //alert("now ", now);
    this.ordertimetoshow = now;

    this.datetimeEmpty = localStorage.getItem("orderdate");
    this.ordertime = localStorage.getItem("ordertime");
    this.order_later = this.getOrderLater;
    this.order_now = this.getOrderNow;

    this.order_later_start_time = localStorage.getItem(
      "order_later_start_time"
    );
  },
  updated() {
    var days = parseInt(this.digital_order_setting.order_later_days_limit) - 1; // Days you want to subtract
    //("Days are "+)
    // console.log("days ", days);
    var date = new Date();
    var last = new Date(date.getTime() + days * 24 * 60 * 60 * 1000);
    var day1 = last.getDate();
    var month1 = last.getMonth() + 1;
    var year1 = last.getFullYear();

    var dateString = year1 + "-" + month1 + "-" + day1;

    // console.log("dateString ", dateString);
    var dateTime = moment(this.digital_order_setting.todays_date, "YYYY-MM-DD");
    var dateTimeEnd = moment(dateString, "YYYY-MM-DD");

    //console.log("Concated date "+dateTimeEnd.format('YYYY-MM-DD'))

    this.minDatetime = dateTime.format("YYYY-MM-DD");
    this.maxDatetime = dateTimeEnd.format("YYYY-MM-DD");

    /* console.log(
      "minDatetime ",
      JSON.stringify(this.digital_order_setting.order_later_time_slots)
    ); */

    this.order_later_time_slots =
      this.digital_order_setting.order_later_time_slots;
  },
};
</script>
<style>
.custom-select {
  display: inline-block;
  width: 100%;
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: #fff url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") right 0.75rem center/8px 10px no-repeat;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.custom-control {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5rem;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
}

input[type="radio"] {
  margin: 0px -20px 0;
  height: 20px;
  margin-top: 1px \9;
  line-height: normal;
  width: 16px;
  position: absolute;
  display: none;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}

.order_later {
  background-color: #ffbb0e;
  color: #fff;
  width: 100%;
}

.order_now {
  background-color: #ffbb0e;
  color: #fff;
  width: 100%;
}

.order_now_active {
  background-color: #f5c464;
  color: #fff;
  width: 100%;
}

.order_later_active {
  background-color: #f5c464;
  color: #fff;
  width: 100%;
}
</style>
